//const serverUrl = 'https://dzp2adr3c7.execute-api.us-east-1.amazonaws.com/Prod'
//const serverUrl = 'http://192.168.2.118:3000'
//const serverUrl = 'https://6uh9bhy2mg.execute-api.us-east-1.amazonaws.com/stage'
const serverUrl = `${process.env.VUE_APP_SERVERURL}`;
const create_campaign_serverUrl = `${process.env.VUE_APP_CREATE_CAMPAIGN_SERVERURL}`;
const presighnedUrl = `${process.env.VUE_APP_GET_PRESIGHNED_URL}`;
const environment = `${process.env.VUE_APP_ENVIRONMENT}`
const templateURl = `${process.env.VUE_APP_TEMPLATE_URL}`
const googleAnalyticsKey = `${process.env.VUE_APP_GOOGLE_ANALYTICS_KEY}`
export {
    serverUrl,
	create_campaign_serverUrl,
	presighnedUrl,
	environment,
	templateURl,
	googleAnalyticsKey
}
